import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ResourcePage from "@/components/common/ResourcePage";
import { CsvImportDialog } from "@/components/common/CsvImportDialog";
import { PageHeader } from "@/components/common/States";
import { useWorkspace } from "@/context/WorkspaceContext";
import { companies } from "@/lib/resources";

export default function Companies() {
  const navigate = useNavigate();
  const { can } = useWorkspace();
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div data-testid="companies-page">
      <PageHeader eyebrow="CRM" title="Companies" description="Legal entities you sell to. Physical locations are tracked separately as operating sites." />
      <ResourcePage config={companies} onRowClick={(r) => navigate(`/companies/${r.id}`)} reloadKey={reloadKey}
        toolbarExtra={can("write") && <CsvImportDialog entity="companies" label="companies" onDone={() => setReloadKey((k) => k + 1)} />} />
    </div>
  );
}
